/**
* Scrolling Jump Links JS
* -----------------------------------------------------------------------------
*/

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {ScrollToPlugin} from 'gsap/ScrollToPlugin.js'; // Added this

gsap.registerPlugin( ScrollTrigger, ScrollToPlugin ); // Register both

( function( app ) {
  const COMPONENT = {

    className: 'scrolling-jump-links',
    selector: function() {
      return '.' + this.className;
    },

    init: function() {
      if ( window.innerWidth > 768 ) {
        const $container = $( this.selector() );
        const $allLinks = $container.find( '.jump-links-list__list a' );

        const getTopOffset = () => {
          let offset = $( 'header' ).outerHeight() + 40;
          if ( $( 'body.logged-in' ).length > 0 ) {
            offset += 32;
          }
          return offset;
        };

        $allLinks.on( 'click', function( e ) {
          e.preventDefault();
          const target = $( this ).attr( 'href' );

          gsap.to( window, {
            // duration: 0.5,
            scrollTo: {
              y: target,
              offsetY: getTopOffset(),
            },
            ease: 'power2.out',
          } );
        } );

        $container.find( '.jump-links-list__content' ).each( function() {
          const jumpLinkSelector = $( this ).attr( 'data-jump-link' );
          const $thisLink = $( jumpLinkSelector );

          ScrollTrigger.create( {
            trigger: this,
            start: () => `top top+=${getTopOffset() + 5}`,
            end: () => `bottom top+=${getTopOffset()}`,
            onToggle: ( self ) => {
              if ( self.isActive ) {
                $allLinks.removeClass( 'active' );
                $thisLink.addClass( 'active' );
              }
            },
            onLeaveBack: () => $thisLink.removeClass( 'active' ),
            onLeave: () => $thisLink.removeClass( 'active' ),
            invalidateOnRefresh: true,
          } );
        } );

        window.addEventListener( 'load', () => {
          ScrollTrigger.refresh();
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'scrolling-jump-links', COMPONENT );
} )( app );
